import React from "react";
import { Create } from "react-admin";
import { PrescriberForm } from "./PrescriberForm";

export const PrescriberCreate = (props) => (
  <Create title="Criar Prescritor" {...props}>
    <PrescriberForm {...props} />
  </Create>
);
